declare namespace $ {

	type $mol_text__text_shm_hitalama_map_rights_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_rights['map_type'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_select__hint_shm_hitalama_map_rights_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_select['hint'] >
	>
	type $mol_select__dictionary_shm_hitalama_map_rights_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_rights['team_member_options'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_shm_hitalama_map_rights_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_rights['client_id'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_labeler__title_shm_hitalama_map_rights_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_map_rights_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_string__hint_shm_hitalama_map_rights_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_hitalama_map_rights_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_rights['client_id'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_hitalama_map_rights_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_map_rights_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_rights_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__enabled_shm_hitalama_map_rights_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_rights['grant_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_rights_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_rights['grant_read'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_major__title_shm_hitalama_map_rights_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__enabled_shm_hitalama_map_rights_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_rights['grant_enabled'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_major__click_shm_hitalama_map_rights_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_rights['grant_write'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_view__sub_shm_hitalama_map_rights_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_shm_hitalama_map_rights_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_rights['message'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_shm_hitalama_map_rights_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_shm_hitalama_map_rights_20 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_list__rows_shm_hitalama_map_rights_21 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_rights['access_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $shm_hitalama_profile_badge__name_shm_hitalama_map_rights_22 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_rights['access_name'] >
		,
		ReturnType< $shm_hitalama_profile_badge['name'] >
	>
	type $shm_hitalama_profile_badge__avatar_uri_shm_hitalama_map_rights_23 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_rights['access_avatar_uri'] >
		,
		ReturnType< $shm_hitalama_profile_badge['avatar_uri'] >
	>
	type $mol_view__sub_shm_hitalama_map_rights_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_rights_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_select__dictionary_shm_hitalama_map_rights_26 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_rights['access_rank_options'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_shm_hitalama_map_rights_27 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_rights['access_rank'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__enabled_shm_hitalama_map_rights_28 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_rights['access_change_enabled'] >
		,
		ReturnType< $mol_select['enabled'] >
	>
	type $mol_select__Filter_shm_hitalama_map_rights_29 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_select['Filter'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_rights_30 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__enabled_shm_hitalama_map_rights_31 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_rights['access_change_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_rights_32 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_rights['access_revoke'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_hitalama_map_rights_33 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_rights_34 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_map_rights extends $mol_view {
		grant_pending_auto( ): any
		map_type( ): string
		Map_type( ): $mol_text
		team_member_options( ): Record<string, any>
		client_id( next?: string ): string
		Team_member( ): $mol_select
		Team_member_label( ): $mol_labeler
		Client_id( ): $mol_string
		Client_label( ): $mol_labeler
		grant_enabled( ): boolean
		grant_read( next?: any ): any
		Grant_read( ): $mol_button_minor
		grant_write( next?: any ): any
		Grant_write( ): $mol_button_major
		Actions( ): $mol_view
		message( next?: string ): string
		Message( ): $mol_text
		Access_title( ): $mol_view
		Access_empty( ): $mol_text
		access_rows( ): readonly(any)[]
		Access_list( ): $mol_list
		rows( ): readonly(any)[]
		access_name( id: any): string
		access_avatar_uri( id: any): string
		Access_person( id: any): $shm_hitalama_profile_badge
		access_id( id: any): string
		Access_id( id: any): $mol_view
		Access_identity( id: any): $mol_view
		access_rank_options( ): Record<string, any>
		access_rank( id: any, next?: string ): string
		access_change_enabled( id: any): boolean
		Access_rank( id: any): $mol_select
		access_revoke( id: any, next?: any ): any
		Access_revoke( id: any): $mol_button_minor
		Access_actions( id: any): $mol_view
		map( ): $shm_hitalama_map
		team( next?: any ): any
		grant_client( next?: string ): string
		grant_rank( next?: number ): number
		grant_success( next?: string ): string
		access_revision( next?: number ): number
		auto( ): readonly(any)[]
		sub( ): ReturnType< $shm_hitalama_map_rights['rows'] >
		Access_row( id: any): $mol_view
	}
	
}

//# sourceMappingURL=rights.view.tree.d.ts.map